import {Component, OnInit} from '@angular/core';
import {
    ICsDetailGridRenderer
} from '@app/shared/cs-ag-grid-js/cs-ag-grid-cell-renderers/cs-ag-grid-cell-renderers.interface';
import {ICsGridApi} from '@app/shared/cs-ag-grid-js/cs-ag-grid-js.interface';

@Component({
    selector: 'app-cs-ag-detail-grid-renderer',
    template: `
        <div class="detail-grid-wrapper">
            <app-cs-ag-grid-js
                [config]="params.config"
                (onGridInit)="onGridInit($event)">
            </app-cs-ag-grid-js>
        </div>`
})
export class CsAgDetailGridRendererComponent implements OnInit {

    params: ICsDetailGridRenderer;

    constructor() {
    }

    ngOnInit() {
    }

    onGridInit(instance: ICsGridApi) {
        this.params['node']['parent']['detailMetaData']['gridInstance'] = instance;
    }
}
